import React from "react";
import { PowerBITitle, PowerBIURL } from "../../utility/apiURLS";

const PowerBIReport = () => {
  return (
    <div style={{  height: "100vh", justifyContent: "center", alignItems: "center" }}>
      <iframe 
        title={PowerBITitle} 
        width="1140" 
        height="541.25" 
        src={PowerBIURL}
        frameborder="0" 
        allowFullScreen="true"
        style={{
          width: "100%",
          height: "100%",
          
          margin: 0,
          padding: 0 
        }} >
        </iframe>
    </div>
  );
};

export default PowerBIReport;
